import { Component, Output, type OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { SettlementsFacade } from '../../../+state/settlements/settlements.facade';

@Component({
  standalone: false,
  selector: 'odin-settlement-daily-report-download',
  templateUrl: './settlement-daily-report-download.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./settlement-daily-report-download.component.scss'],
})
export class SettlementDailyReportDownloadComponent implements OnInit {
  @Output() newDailySettlement = new EventEmitter();
  @Output() newDailySettlementCSV = new EventEmitter();
  @Output() newDailyMerchantReport = new EventEmitter();

  loading$!: Observable<boolean>;

  constructor(private facade: SettlementsFacade) {}

  ngOnInit() {
    this.loading$ = this.facade.getDailySettlementReportsLoader$;
  }

  downloadDailySettlementReport() {
    this.newDailySettlement.emit();
  }

  downloadDailySettlementReportCSV() {
    this.newDailySettlementCSV.emit();
  }

  downloadDailyMerchantReport() {
    this.newDailyMerchantReport.emit();
  }
}
